import i18n from './i18n'
import landingHeader from './landing-header'
import overlays from './overlays'
import router from './router'
import sideMenu from './side-menu'
import stocks from './stocks'

export default {
  i18n,
  landingHeader,
  overlays,
  router,
  sideMenu,
  stocks
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js